/**
 * Splits `ids` into consecutive chunks of at most `size` each, preserving
 * order. Used to keep a batch `ids` read (e.g. `listClients({ ids })`,
 * `getAllStoredEmails({ ids })`) within the backend's pagination `limit` cap.
 */
export function chunkIds(ids: string[], size: number): string[][] {
	const chunks: string[][] = [];
	for (let i = 0; i < ids.length; i += size) {
		chunks.push(ids.slice(i, i + size));
	}
	return chunks;
}

/**
 * Max ids a single `ids`-filtered list read can resolve - mirrors the backend's
 * `PaginationQuerySchema.limit` cap (`packages/types/src/api/common.ts`), a
 * repo-wide pagination ceiling shared by every list endpoint (not something to
 * special-case away for one caller). Any caller resolving more ids than this
 * splits them with `chunkIds` and merges the responses.
 */
export const CLIENT_ID_RESOLUTION_BATCH_SIZE = 100;
